module.exports = __webpack_public_path__ + "img/notifications.d1f13234.svg";